// extracted by mini-css-extract-plugin
module.exports = {"Layout":"Layout_Layout__2kcOK","LayoutImg":"Layout_LayoutImg__U64HI"};